export const defaultLiveChatWidgetGeneralStyles = {
  position: "absolute",
  justifyContent: "center",
  alignItems: "center"
};